import { CardType, OWNED } from 'types/deck'

import globalVariables from 'assets/scss/variables'

import styles from './collectionDot.module.scss'

type Props = {
  card: CardType
}

const CollectionDot = ({ card }: Props) => {
  const collectionColor =
    card.owned === OWNED.NO
      ? 'transparent'
      : card.owned === OWNED.PRINTING
        ? globalVariables.quantityBlue
        : globalVariables.quantityGreen

  return <span className={styles.collectionDot} style={{ backgroundColor: collectionColor }} />
}
export default CollectionDot
